;(function($, window, document, undefined) {
	"use strict";

	var pluginName = "responsiveBG",
		defaults = {
      timeout: 0
    };

	function Plugin(element, options) {
		this.element = element;
		this.$element = $(this.element);

		this.settings = $.extend( {}, defaults, options );
		this._defaults = defaults;
		this._name = pluginName;

    this.init();
	}

	$.extend(Plugin.prototype, {
		init: function() {
      this.setImage();

      $(window).resize(debounce(function() {
        this.updateImage();
      }, 500).bind(this));
		},
		setImage: function() {
			var $el = this.$element;
			var onLoadCallback = this.settings.onLoad;
			var backgroundImages = $el.data('background-images');
	    if($(window).width() < ScreenSM) {
	      $el.removeClass('responsive-bg--default').addClass('responsive-bg--mobile');
	      var imgSrc = backgroundImages['mobile'];
	      if(!imgSrc) {
	        imgSrc = backgroundImages['default'];
	      }
	    } else {
	      $el.removeClass('responsive-bg--mobile').addClass('responsive-bg--default');
	      var imgSrc = backgroundImages['default'];
	    }
	    var img = new Image();
	    $el.css('background-image', 'url(' + imgSrc + ')');
	    img.onload = function() {
	      $el.addClass('responsive-bg--loaded');
				if(onLoadCallback) {
					onLoadCallback();
				}
	    }
	    img.src = imgSrc;
		},
		updateImage: function() {
			var $el = this.$element;
			if($(window).width() < ScreenSM && !$el.hasClass('responsive-bg--mobile')) {
	      this.setImage();
	    } else if($(window).width() > ScreenSM && $el.hasClass('responsive-bg--mobile')) {
	      this.setImage();
	    }
		}
	});

	$.fn[pluginName] = function(options) {
		return this.each(function() {
			if(!$.data(this, "plugin_" + pluginName)) {
				$.data(this, "plugin_" +
					pluginName, new Plugin(this, options));
			}
		});
	};
})(jQuery, window, document);